<template>
  <div class="filters-action">
    <div class="filters-action__wrapp-button button-apply-filter">
      <button class="btn btn-primary btn-primary-black apply-filter" :disabled="disabled" @click.prevent="$emit('apply')">
        <svg class="o-icon"><use xlink:href="#check"></use></svg>
        <span class="text">{{$t('apply-filter')}}</span>
      </button>
    </div>
    <div class="filters-action__wrapp-button wrapp-button-filter button-clear-filter">
      <button class="btn btn-primary btn-primary-black clear-filter" :disabled="disabled" @click.prevent="$emit('clear')" v-show="showClear">
        <svg class="o-icon"><use xlink:href="#close"></use></svg>
        <span class="text">{{ $t('clear-filter') }}</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showClear: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>
